import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/forgot-password', { email });
    } finally {
      setSent(true);
      setBusy(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-md border border-slate-200 p-8">
        <h1 className="text-xl font-bold text-brand-navy mb-2">Reset password</h1>
        <p className="text-slate-500 text-sm mb-6">
          Enter your email. If it's registered, you'll receive a reset link.
        </p>

        {sent ? (
          <div className="bg-emerald-50 border border-emerald-200 rounded-md p-3 text-sm text-emerald-800">
            If the email is registered, a reset link has been sent. Check your inbox.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <input
              type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-slate-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-navy/40"
              placeholder="you@company.com"
            />
            <button
              type="submit" disabled={busy}
              className="w-full bg-brand-navy text-white font-semibold rounded-md py-2 hover:bg-brand-navy/90 disabled:opacity-50"
            >
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <div className="mt-4 text-center text-sm">
          <Link to="/login" className="text-brand-navy hover:underline">Back to sign in</Link>
        </div>
      </div>
    </main>
  );
}
